import { useTranslation } from "react-i18next";
import useMdiStore from "store/menus";
import { useMenuClick } from "./handles";
import "./aside.scss";

export default function Aside() {
  const { t } = useTranslation();

  const { activePageId, menuList } = useMdiStore();

  const { onMenuClick } = useMenuClick();

  const menuId = !activePageId ? "home" : activePageId?.split("_")[0];

  return (
    <>
      <aside>
        <ul className="flex col gap-4">
          {menuList &&
            menuList.map((menu: any) => {
              return (
                <li
                  key={menu.id}
                  className={`menu ${menuId === menu.id ? "active" : ""}`}
                >
                  {menu.id === "home" && (
                    <button
                      className="_ttl"
                      onClick={() => onMenuClick({ item: menu })}
                    >
                      {t(menu.title)}
                    </button>
                  )}
                  {menu.id !== "home" && (
                    <button className="_ttl" onClick={() => {}}>
                      {t(menu.title)}
                    </button>
                  )}
                  <ul className="flex col">
                    {menu.menu.map((item: any) => {
                      return (
                        <li key={item.id}>
                          <button
                            className={`${
                              activePageId === item.id ? "text-red-300" : ""
                            }`}
                            onClick={() =>
                              onMenuClick({
                                item: {
                                  ...item,
                                  title: menu.title,
                                },
                              })
                            }
                          >
                            {t(item.name)}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
        </ul>
      </aside>
    </>
  );
}
